import { defineMessages } from 'react-intl';

export default defineMessages({
  companyOverview: 'Company Overview',
  trades: 'Trades',
  officeLocation: 'Office Location Map',
  qScore: 'Q Score',
  shareProfile: 'Share Profile',
  linkCopied: 'Link Copied!',
  viewInCompass: 'View in COMPASS'
});
